import { z } from 'zod';

export const $VacationGenerateSchema = z.object({
  vacancyName: z
    .string({ message: 'Введите название' })
    .max(250, 'Превышено максимальное количество символов'),
  generationRequest: z
    .string({ message: 'Введите запрос на генерацию в свободной форме' })
    .max(3000, 'Превышено максимальное количество символов'),
});

export type VacationGenerateSchema = z.infer<typeof $VacationGenerateSchema>;
